import { ImportStatus } from '@synergy/models';

const translationObject: { [Key in ImportStatus]: string } = {
    [ImportStatus.Created]: 'app.importStatus.created',
    [ImportStatus.Aborted]: 'app.importStatus.aborted',
    [ImportStatus.Published]: 'app.importStatus.published',
    [ImportStatus.Publishing]: 'app.importStatus.publishing',
    [ImportStatus.DeleteExistingProducts]: 'app.importStatus.deleteExistingProducts',
    [ImportStatus.CreatingCategories]: 'app.importStatus.creatingCategories',
    [ImportStatus.Calculating]: 'app.importStatus.calculating',
    [ImportStatus.ReadyToPublish]: 'app.importStatus.readyToPublish',
    [ImportStatus.Receiving]: 'app.importStatus.receiving',
    [ImportStatus.Archived]: 'app.importStatus.archived',
    [ImportStatus.Scheduled]: 'app.importStatus.scheduled',
};

export const getImportStatusTranslationId = (status: ImportStatus): string => {
    return (status && translationObject[status]) || status.toString();
};
